import React from "react";

import Thumbnail from "src/components/thumbnail";
import { Media } from "src/types/media";

import _ from "lodash";
import cx from "classnames";
import styles from "./groupThumbnail.module.scss";

interface GroupThumbnailProps {
  icons: Media[];
}

const GroupThumbnail: React.FC<GroupThumbnailProps> = ({ icons }) => {
  return (
    <div className={styles.container}>
      {/* Main Image */}
      <div className={styles.first}>
        <Thumbnail
          className={styles.icon}
          media={_.get(icons, "[0]")}
          defaultImage="/images/assets/default_asset.jpg"
        />
      </div>

      {/* Small Overlapping Images */}
      <div className={styles.second}>
        <Thumbnail
          className={styles.icon}
          media={_.get(icons, "[1]")}
          defaultImage="/images/assets/default_asset.jpg"
        />
      </div>
      <div className={styles.third}>
        <Thumbnail
          className={styles.icon}
          media={_.get(icons, "[2]")}
          defaultImage="/images/assets/default_asset.jpg"
        />
      </div>
    </div>
  );
};

export default GroupThumbnail;
